var headerHeight = 65;

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    if(!jQuery('body').hasClass('home-navigation')){
      jQuery('.primary-nav-container').appendTo('.banner');
    }
  },
};

function getCurrentScroll() {
  return window.pageYOffset || document.documentElement.scrollTop;
}

$(window).scroll(function() {
  if(jQuery('body').hasClass('home')){
    var scroll = getCurrentScroll();
    if ( scroll >= headerHeight ) {
      $('body, .header-container').addClass('home-navigation');
    }
    else {
      $('body, .header-container').removeClass('home-navigation');
    }

    if(!jQuery('body').hasClass('home-navigation')){
      jQuery('.primary-nav-container').appendTo('.banner');
    } else {
      jQuery('.primary-nav-container').appendTo('body');
    }
  }
});



// WEBPACK FOOTER //
// ./scripts/routes/home.js